import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-simple-selfie-capture',
  templateUrl: './simple-selfie-capture.component.html',
  styleUrls: ['./simple-selfie-capture.component.scss']
})
export class SimpleSelfieCaptureComponent implements OnInit {
  webcamImage: WebcamImage | undefined
  
  showbtn = true;
  showWebCam = true;
  continueImage = false;
  isCameraExist = true;
  imageAsBase64: any;
  errors: WebcamInitError[] = [];
  private trigger: Subject<void> = new Subject<void>();
  private nexrWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  constructor(private _dialog: MatDialog,protected _commonService: CommonService,
    public dialogRef: MatDialogRef<SimpleSelfieCaptureComponent>,

  ) {

  }

  ngOnInit(): void {
    
    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        this.isCameraExist = mediaDevices && mediaDevices.length > 0;
      }
    )
  }
  takeSnapshot() {
    this.showWebCam = false;
    this.trigger.next();

  }
  retake() {
    this.webcamImage = null;
    this.showWebCam = true;
  }
  continue() {
    this.dialogRef.close(this.webcamImage);

  }

  handleInitError(error: WebcamInitError) {
    this.errors.push(error)
  }
  handleImage(webcamImage: WebcamImage) {
    
    this.webcamImage = webcamImage
    this.imageAsBase64 = webcamImage.imageAsBase64
    this.showWebCam = false;

  }
  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nexrWebcam.asObservable();
  }
}